import boxOfferPlanIcon from "@images/illustrations/boxOfferPlanIcon.svg"
import { BoxLeadOffersWrapper } from "@modules/boxLead/components/boxLeadInfo/boxLeadOffersWrapper"
import { useBoxLead } from "@modules/boxLead/hooks/useBoxLeadDetails"
import { BoxStaffPermissions } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffPermission } from "@modules/boxStaff/hooks/useBoxStaffPermissions"
import { word } from "@modules/core/utils/i18n"
import { MemberOffersWrapperSkeleton } from "@modules/members/memberOffers/components/memberOffersWrapperSkeleton"
import {
  MemberSendOfferModal,
  MemberSendOfferModalRef,
} from "@modules/members/sendOfferToMember/components/memberSendOfferModal"
import { HUText } from "@modules/ui/components/huText"
import { Suspense, useRef } from "react"
import { useTheme } from "styled-components"

type Props = {
  leadId: string
} & React.ComponentProps<"div">

export function BoxLeadOffersLayout({ leadId, ...props }: Props) {
  const theme = useTheme()
  const { data: leadDetails } = useBoxLead(leadId)

  const memberSendOfferModal = useRef<MemberSendOfferModalRef>(null)
  const canSendOffer = useBoxStaffPermission(BoxStaffPermissions.SEND_OFFER)

  const handleSendOfferModal = () => {
    memberSendOfferModal.current?.open()
  }

  if (!leadDetails.user?.id) {
    return null
  }

  return (
    <>
      <div className="flex flex-column w-full gap-4 pb-4" {...props}>
        {/* Send offer button */}
        {canSendOffer && (
          <div
            onClick={handleSendOfferModal}
            className="
              shiny-hover flex mx-1 cursor-pointer
              rounded-card border-2 border-electricPurple-400
              p-2 gap-2 justify-content-center align-items-center bg-neutralColor-50
              "
          >
            <img src={boxOfferPlanIcon} />
            <HUText fontStyle="TS" color={theme.mainWhite}>
              {word("box.member.table.offer.menu.sendOffer")}
            </HUText>
          </div>
        )}
        <div className="flex w-full border-1 border-solid border-neutralColor-200" />
        {/* Offers List */}
        <Suspense fallback={<MemberOffersWrapperSkeleton />}>
          <BoxLeadOffersWrapper userId={leadDetails.user.id} />
        </Suspense>
      </div>

      <MemberSendOfferModal userId={leadDetails.user.id} ref={memberSendOfferModal} />
    </>
  )
}
